module.exports = __webpack_public_path__ + "static/media/Regulamento_0202409319_VB.db69acb7.pdf";